import { useState, useMemo, useEffect } from 'react';
import ProzoDataGrid from "../../common/ProzoDataGrid";
import CopyIcon from "../../common/CopyIcon";
import { Chip, Grid, Button, Tooltip, IconButton, Typography, Card, CardContent, Switch, Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Table, TableHead, TableBody, TableRow, TableCell, TableContainer, Paper, Box, Divider, Tabs, Tab } from '@mui/material';
import StatusChip from '../../common/StatusChip';
import PaymentBadge from '../../common/PaymentBadge';
import OrderRowActions from '../../common/OrderRowActions';
import { FieldLabel, FilterField, FilterDateField } from '../../common/FilterBar';
import { formatDate, maskAddress, parseDateAndTime, shouldMaskData, shouldMaskDataReverse } from '../../helpers/UtilityHelper';
import { formatCurrency } from '../../common/util';
import { useForm } from 'react-hook-form';
import { FormProvider, RHFDateRangePickerField, RHFSelectField, RHFTextField } from "../../common/hook-form"
import OrderStatusFilter, { OrderStatusChips, orderStatusClause } from './OrderStatusFilter';
import useNdr from "../../hooks/useNdr"
import useSessionState from "../../hooks/useSessionState";
import VisibilityIcon from '@mui/icons-material/Visibility';
import { Link } from 'react-router-dom';
import { CourierFilter, MerchantFilterCached } from '../../common/ProshipFormComponents';
import ScheduleIcon from '@mui/icons-material/Schedule';
import MUIModal from '../../components/MuiModal';
import Loader from '../../common/Loader';
import Eddupdate from './EddUpdate';
import PageTitle from '../../components/PageTitle';
import { NON_ABD_FILTER, NON_ABD_SORT, NON_ABD_DEFAULT_WINDOW_DAYS, PENDING_AWB_LIMIT, AWB_TAB } from './nonAbdFilter';
import { useGetAllOrdersQuery } from '../../redux/commonApiCalls';
import { apiConstants, get, postGeneric, getGeneric } from '../../common/constants';
import { recalculatePricing } from '../../common/recalculatePricing';
import { useSnackbar } from 'notistack';
import SyncIcon from '@mui/icons-material/Sync';
import { DocumentScanner } from '@mui/icons-material';
import Pods from './Pods';
import AppointmentDelivery from './AddAppDelivery';
import AddAdditionalDocuments from './AddAdditionalDocuments';
import { categoryLabel } from './ExtraDocsEditor';
import DocumentsModal from './DocumentsModal';
import PostAddIcon from '@mui/icons-material/PostAdd';
import { useSelector } from 'react-redux';
import jwt_decode from "jwt-decode";
import { getToken } from '../../helpers/ReduxHelpers';
import FunctionsIcon from '@mui/icons-material/Functions';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import AssignmentIcon from '@mui/icons-material/Assignment';
import DescriptionIcon from '@mui/icons-material/Description';
import UploadFileIcon from '@mui/icons-material/UploadFile';
import { LoadingButton } from '@mui/lab';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import TimelineIcon from '@mui/icons-material/Timeline';
import FactCheckIcon from '@mui/icons-material/FactCheck';
import LockOpenIcon from '@mui/icons-material/LockOpen';
import { useLazyGeoPincodesQuery, useNabdLookupQuery } from '../../redux/ptlNabdApiSlice';
import { GeoCityFilter, GeoStateFilter } from '../../common/GeoFilters';
import CaseDrawer from '../ptl-edd-breach/components/CaseDrawer';
import { LateTag, OwnerChip } from '../ptl-edd-breach/eddBreachUi';

const FILTER_DEFAULTS = {
    status: [],
    courier: '',
    merchant: '',
    reference: '',
    awb: '',
    city: '',
    state: '',
    fromDate: '',
    toDate: '',
    channel: '',
    appointdeliveryRequired: '',
    hasRtoRequest: ''
};

// Filters come back from sessionStorage as JSON: turn the date strings back into Dates.
const reviveFilters = (f) => (f && typeof f === 'object' && !Array.isArray(f))
    ? { ...f, fromDate: f.fromDate ? new Date(f.fromDate) : '', toDate: f.toDate ? new Date(f.toDate) : '' }
    : f;

const B2BOrderSummary = ({ nonAbdOnly = false }) => {
    const methods = useForm({ defaultValues: FILTER_DEFAULTS });
    const {
        handleSubmit,
        reset,
    } = methods;

    // Applied filters, page, page size and AWB tab are kept for this browser tab, so opening a
    // shipment and coming back (Back button or browser back) returns to the same list.
    const storeKey = `ptlShipments:${nonAbdOnly ? 'nonAbd' : 'all'}`;
    const [page, setPage] = useSessionState(`${storeKey}:page`, 0);
    const [filterChange, setFiltersChange] = useState(0);
    const [filters, setFilters] = useSessionState(`${storeKey}:filters`, 0, reviveFilters);
    const [sizePerPage, setSizePerPage] = useSessionState(`${storeKey}:pageSize`, 20);
    const [open, setOpen] = useState(false);
    const [openAppointmentDelivery, setOpenAppointmentDelivery] = useState(false);
    const [awb, setAwb] = useState()
    const [reload, setReload] = useState(0)
    const { enqueueSnackbar } = useSnackbar();
    const [fetchPincodes] = useLazyGeoPincodesQuery();
    const [isCalculating, setIsCalculating] = useState(false);
    const [pods, setPods] = useState(false);
    const [delConfirm, setDelConfirm] = useState(false);
    const [appDetails, setAppDetails] = useState(null);
    const [id, setId] = useState();
    const { report } = useSelector(state => state);
    const { piiAccessAllow } = jwt_decode(getToken());
    const [abdData, setABDData] = useState(null);
    const [isAbdLoading, setIsAbdLoading] = useState(false);
    const [rowSelectionModel, setRowSelectionModel] = useState([]);
    const [selectedShipmentsMap, setSelectedShipmentsMap] = useState({});
    const [bulkConfirmOpen, setBulkConfirmOpen] = useState(false);
    const [bulkStatusCode, setBulkStatusCode] = useState(true);
    const [isBulkAbdLoading, setIsBulkAbdLoading] = useState(false);
    const [bulkResults, setBulkResults] = useState(null);
    const [bulkResultsOpen, setBulkResultsOpen] = useState(false);
    const [eddDataOpen, setEddDataOpen] = useState(false);
    const [eddRowData, setEddRowData] = useState(null);
    const [docsModalOpen, setDocsModalOpen] = useState(false);
    const [docsRowData, setDocsRowData] = useState(null);
    const [docsViewOpen, setDocsViewOpen] = useState(false);
    const [docsViewRow, setDocsViewRow] = useState(null);
    const [apptDocsOpen, setApptDocsOpen] = useState(false);
    const [apptDocsRow, setApptDocsRow] = useState(null);
    const [awbTab, setAwbTab] = useSessionState(`${storeKey}:awbTab`, AWB_TAB.GENERATED);

    // Show the restored filters in the form too. pincodes is derived on submit, not a form field.
    useEffect(() => {
        if (filters && typeof filters === 'object' && !Array.isArray(filters)) {
            const { pincodes, ...formValues } = filters;
            reset({ ...FILTER_DEFAULTS, ...formValues });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    // const self = [{ label: "TRUE", value: "Selfship" }, { label: "FALSE", value: "" }]

    const { request, pendingCountRequest, useDefaultWindow } = useMemo(() => {
        // const exclude = "courier,merchant,version,itemList,orderManifest,invoiceUrl,courierPricingRTO,courierPricing,overriddenCourierAccountCode,actualCourierProviderName,isDiscrepancyRaised,discrepancyId,securityKey,sortCode,channelType,channelName,createdByUser,skipRule,modifiedByUser,rvp_reason,channel_name,customerDetail,cpErrorList,mongoLabelSignedUrlDetails,overriddenCourierRule,mongoInvoiceSignedUrlDetails,merchantPricing.pricingObj,merchantPricing.merchantRateCard,modifiedByUser,lastModifiedDate,terminalStatus";
        const includes = "appointmentDeliveryData,appointdeliveryRequired,appointmentDelivery,additionalDocuments,terminalStatus,edd,orderDate,id,reference,invoiceValue,pods,shippingLabelId,awbRegisteredDate,merchantPricing.zone,merchantDetail,courierDetail,pickupDetails.from_pincode,pickupDetails.from_city,deliveryDetails.to_pincode,deliveryDetails.to_state,deliveryDetails.to_city,channelName,orderStatus,shipmentDetail,paymentMode,awbNumber,referenceNumber,merchantPricing.price"
        const andfilter = [];
        const orFilter = [];
        andfilter.push({ "field": "shipmentType", operator: "eq", value: "B2B" })
        if (nonAbdOnly) andfilter.push(NON_ABD_FILTER)
        const statusClause = orderStatusClause(filters.status);
        if (statusClause) andfilter.push(statusClause)
        if (filters.awb) {
            // Allow comma-separated AWB lookup. Single value → eq for efficient
            // direct match; multiple values → in with an array.
            const awbList = String(filters.awb)
                .split(',')
                .map((s) => s.trim())
                .filter(Boolean)
            if (awbList.length === 1) {
                andfilter.push({ "field": "awbNumber", "operator": "eq", "value": awbList[0] });
            } else if (awbList.length > 1) {
                andfilter.push({ "field": "awbNumber", "operator": "in", "value": awbList });
            }
        }
        // Non-ABD: State / City are picked from pincode_master and resolved to pincodes on Filter (common/GeoFilters), so the
        // list matches the delivery pincode, whatever spelling the order carries. PTL only: rides the abd_baseline index.
        if (nonAbdOnly && Array.isArray(filters.pincodes)) {
            andfilter.push({ "field": "deliveryDetails.to_pincode", "operator": "in", "value": filters.pincodes });
        }
        if (!nonAbdOnly && filters.city) {
            andfilter.push({ "field": "deliveryDetails.to_city", "operator": "eq", "value": filters.city });
        }
        if (!nonAbdOnly && filters.appointdeliveryRequired !== undefined && filters.appointdeliveryRequired !== null && filters.appointdeliveryRequired !== '') {
            andfilter.push(filters.appointdeliveryRequired ? { "field": "appointdeliveryRequired", "operator": "eq", "value": true } : NON_ABD_FILTER);
        }
        if (filters.hasRtoRequest !== undefined && filters.hasRtoRequest !== null && filters.hasRtoRequest !== '') {
            andfilter.push({ "field": "rtoRequestDetails", "operator": "exists", "value": filters.hasRtoRequest });
        }
        if (!nonAbdOnly && filters.state) {
            andfilter.push({ "field": "deliveryDetails.to_state", "operator": "eq", "value": filters.state });
        }
        if (filters.merchant) {
            andfilter.push({ "field": "merchant.$id", "operator": "eq", "value": 'ObjectId(\'' + filters.merchant + '\')' });
        }
        if (filters.courier) {
            andfilter.push({ "field": "courier.$id", "operator": "eq", "value": 'ObjectId(\'' + filters.courier + '\')' });
        }
        if (filters.reference) {
            orFilter.push({ "field": "reference", "operator": "like", "value": filters.reference + ".*" });
            orFilter.push({ "field": "shippingLabelId", "operator": "like", "value": filters.reference + ".*" });
        }
        if (filters.fromDate) {
            andfilter.push({ field: "orderDate", operator: "gte", value: formatDate(filters.fromDate, 'yyyy-MM-dd') })
        }
        if (filters.toDate) {
            andfilter.push({ field: "orderDate", operator: "lte", value: formatDate(filters.toDate, 'yyyy-MM-dd') })
        }
        if (filters.channel) {
            andfilter.push({ field: "channelName", operator: "eq", value: "Selfship" })
        }
        // Keep the non-ABD query on an index: bound it to recent AWBs unless the user picked dates
        // or is looking up a specific AWB / reference (those must still find older shipments).
        const useDefaultWindow = nonAbdOnly && !filters.fromDate && !filters.toDate && !filters.awb && !filters.reference;
        const since = new Date();
        since.setDate(since.getDate() - NON_ABD_DEFAULT_WINDOW_DAYS);
        // Orders whose AWB was never generated have no awbRegisteredDate, so the window above hides
        // them; they get their own tab and query (an $or would push the main query back to 1-3s).
        // orderDate is stored as a 'yyyy-MM-dd' string, so compare it as one.
        const pendingAndfilter = [
            ...andfilter,
            { field: "awbRegisteredDate", operator: "exists", value: false },
            { field: "orderDate", operator: "gte", value: formatDate(since, 'yyyy-MM-dd') },
        ];
        // Lightweight query that only feeds the tab badge.
        const pendingCountRequest = useDefaultWindow ? {
            "andfilter": pendingAndfilter,
            "orfilter": orFilter,
            "offset": 0,
            "limit": PENDING_AWB_LIMIT,
            "skipCount": true,
            "includes": "id",
        } : null;
        const showPending = useDefaultWindow && awbTab === AWB_TAB.PENDING;
        const mainAndfilter = useDefaultWindow
            ? [...andfilter, { field: "awbRegisteredDate", operator: "gte", value: `Date('${formatDate(since, 'yyyy-MM-dd')} 00:00:00')` }]
            : andfilter;
        const filter = {
            "andfilter": showPending ? pendingAndfilter : mainAndfilter,
            "orfilter": orFilter,
            "offset": (page) * sizePerPage,
            "limit": sizePerPage,
            // "controllerFilter": true,
            "skipCount": true,
            "includes": includes,
            ...(nonAbdOnly && !showPending && { "sort": NON_ABD_SORT })
        }
        return { request: filter, pendingCountRequest, useDefaultWindow };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [filterChange, page, sizePerPage, reload, nonAbdOnly, awbTab])


    // query for order data
    let { data = [], isFetching, isLoading, refetch } = useNdr({ request: request })
    // The list is fetched without a total (skipCount), so the grid can't tell where it ends.
    // A short page is the last one: give the grid the exact count so "next" is disabled there.
    const rowsOnPage = data?.data?.length ?? 0;
    const knownRowCount = !isFetching && rowsOnPage < sizePerPage ? page * sizePerPage + rowsOnPage : Number.MAX_VALUE;
    const { data: pendingCountData, refetch: refetchPendingCount } = useGetAllOrdersQuery(pendingCountRequest, { skip: !pendingCountRequest });
    const pendingCount = pendingCountData?.data?.length ?? null;
    const showAwbTabs = nonAbdOnly && useDefaultWindow;
    // EDD breach attribution for the rows on screen (Non-ABD view only): awb → { id, owner, lateDays, locked … }
    const pageAwbs = useMemo(() => (data?.data || []).map((r) => r.awb_number).filter(Boolean).slice(0, 100), [data]);
    const { data: nabd = {} } = useNabdLookupQuery(pageAwbs, { skip: !nonAbdOnly || pageAwbs.length === 0 });
    const [nabdCaseId, setNabdCaseId] = useState(null);

    const handleAwbTabChange = (_, v) => {
        setAwbTab(v);
        setPage(0);
        setRowSelectionModel([]);
        setSelectedShipmentsMap({});
    };
    // query for count
    useEffect(() => {
        refetch()
        if (pendingCountRequest) refetchPendingCount()
    }, [reload])

    const handleSync = (awbNumber) => {
        if (awbNumber) {
            setIsCalculating(true)
            get(`${apiConstants.B2B_ORDER_STATUS_SYNC}/${awbNumber}`).then((res) => {
                if (res.status === 200) {
                    enqueueSnackbar('Order Status resynced with courier partner', { variant: 'success' })
                    setReload(reload + 1)
                }
                else {
                    enqueueSnackbar('Response: Order is not updated', { variant: 'error' })
                }
            }).catch((err) => {
                console.log(err)
                enqueueSnackbar(err.response?.data?.message || 'Response: Order is not updated', { variant: 'error' })
            }).finally(() => {
                setIsCalculating(false)
            })
        } else {
            enqueueSnackbar('AWB Number is required', { variant: 'error' })
        }
    }

    const handleFetchPOD = (awbNumber) => {
        setIsCalculating(true)
        if (awbNumber) {
            get(`${apiConstants.B2B_ORDER_STATUS_SYNC_POD}/${awbNumber}`).then((res) => {
                if (res.status === 200) {
                    enqueueSnackbar('Order Status resynced with courier partner', { variant: 'success' })
                }
                else {
                    enqueueSnackbar('Response: Order is not updated', { variant: 'error' })
                }
            }).catch((err) => {
                console.log(err)
                enqueueSnackbar(err.response?.data?.message || 'Response: Order is not updated', { variant: 'error' })
            })
                .finally(() => {
                    setIsCalculating(false)
                })
        }
    }

    const columns = [
        {
            field: 'merchant',
            headerName: 'Merchant', headerAlign: 'left', align: 'left',
            hideSortIcons: true, minWidth: 140, flex: 0.9,
            renderCell: ({ row }) => (
                <Box sx={{ fontSize: 12.5, fontWeight: 600, color: 'text.primary', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', width: '100%' }}>
                    {row?.merchantDetail?.name || '—'}
                </Box>
            ),
        },
        {
            field: 'orderreference',
            headerName: 'Order Details', headerAlign: 'left', align: 'left',
            hideSortIcons: true, minWidth: 180, flex: 1.2,
            renderCell: ({ row }) => (
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.35, width: '100%', py: 0.5 }}>
                    <Box sx={{ fontSize: 12.5, fontWeight: 600, color: 'text.primary', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                        {row.reference}
                    </Box>
                    {row?.awb_number && (
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: '2px' }}>
                            <Box
                                component={Link}
                                to={`/order-detail/${row.awb_number}`}
                                sx={{ fontSize: '12px', fontWeight: 700, color: '#1d4ed8', textDecoration: 'none', borderBottom: '1px dashed #93c5fd', pb: '1px', width: 'fit-content', '&:hover': { color: '#1e40af', borderBottomStyle: 'solid' } }}
                            >
                                {row.awb_number}
                            </Box>
                            <CopyIcon text={row.awb_number} />
                        </Box>
                    )}
                    {row.awbRegisteredDate && (
                        <Box sx={{ fontSize: '11px', color: '#9ca3af' }}>{parseDateAndTime(row.awbRegisteredDate)}</Box>
                    )}
                </Box>
            ),
        },
        {
            field: 'pickup',
            headerName: 'Pincode Details', headerAlign: 'left', align: 'left',
            hideSortIcons: true, minWidth: 160, flex: 1.1,
            renderCell: ({ row }) => (
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.35, width: '100%', py: 0.5 }}>
                    <Box sx={{ fontSize: '12px', color: 'text.primary' }}>
                        <Box component="span" sx={{ fontSize: '10px', fontWeight: 600, color: '#9ca3af', textTransform: 'uppercase', letterSpacing: '0.4px', mr: '4px' }}>Pickup</Box>
                        {shouldMaskDataReverse(report, row, piiAccessAllow)
                            ? `${row.pickup_details?.from_pincode}, ${maskAddress(row.pickup_details?.from_city)}`
                            : `${row.pickup_details?.from_pincode}, ${row.pickup_details?.from_city}`}
                    </Box>
                    <Box sx={{ fontSize: '12px', color: 'text.secondary' }}>
                        <Box component="span" sx={{ fontSize: '10px', fontWeight: 600, color: '#9ca3af', textTransform: 'uppercase', letterSpacing: '0.4px', mr: '4px' }}>Drop</Box>
                        {shouldMaskData(report, row, piiAccessAllow)
                            ? `${row.delivery_details?.to_pincode}, ${maskAddress(row.delivery_details?.to_city)}`
                            : `${row.delivery_details?.to_pincode}, ${row.delivery_details?.to_city}`}
                    </Box>
                </Box>
            ),
        },
        {
            field: 'courier',
            headerName: 'Courier', headerAlign: 'left', align: 'left',
            hideSortIcons: true, minWidth: 150, flex: 1,
            renderCell: ({ row }) => (
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.35, width: '100%', py: 0.5 }}>
                    <Box sx={{ fontSize: 12.5, fontWeight: 600, color: 'text.primary', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                        {row?.courierDetail?.parent || '—'}
                    </Box>
                    {row?.courierDetail?.prozoId && (
                        <Box sx={{ fontSize: '11px', color: '#9ca3af', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                            {row.courierDetail.prozoId}
                        </Box>
                    )}
                </Box>
            ),
        },
        {
            field: 'statusDetails',
            headerName: 'Status', headerAlign: 'left', align: 'left',
            hideSortIcons: true, minWidth: 150, flex: 1,
            renderCell: ({ row }) => (
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5, py: 0.5 }}>
                    <StatusChip status={row?.orderStatus} />
                    <Box component="span" sx={{
                        display: 'inline-block', px: '6px', py: '2px', borderRadius: '3px',
                        fontSize: '10px', fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.4px',
                        bgcolor: row?.appointdeliveryRequired ? '#dbeafe' : '#f9fafb',
                        color: row?.appointdeliveryRequired ? '#1d4ed8' : '#6b7280',
                        border: `1px solid ${row?.appointdeliveryRequired ? '#bfdbfe' : '#e5e7eb'}`,
                        width: 'fit-content',
                    }}>
                        {row?.appointdeliveryRequired ? 'ABD' : 'Non-ABD'}
                    </Box>
                </Box>
            ),
        },
        ...(nonAbdOnly ? [{
            field: 'nabdAttribution',
            headerName: 'Attribution', headerAlign: 'left', align: 'left',
            hideSortIcons: true, minWidth: 120, flex: 0.8,
            renderCell: ({ row }) => {
                const b = nabd[row.awb_number];
                if (!b) return <Box component="span" sx={{ color: 'text.disabled' }}>—</Box>;
                if (!b.owner) return <Button size="small" color="error" variant="outlined" onClick={() => setNabdCaseId(b.id)} sx={{ textTransform: 'none', py: 0 }}>Attribute</Button>;
                return <OwnerChip owner={b.owner} dense />;
            },
        }] : []),
        {
            field: 'weight',
            headerName: 'Weight', headerAlign: 'center', align: 'center',
            hideSortIcons: true, width: 90,
            renderCell: ({ row }) => {
                const w = row.shipment_detail?.[0]?.item_weight;
                return <Box sx={{ fontSize: '13px', fontWeight: 600, color: 'text.primary' }}>{w ? `${(w / 1000).toFixed(2)} kg` : '—'}</Box>;
            },
        },
        {
            field: 'edd',
            headerName: 'EDD', headerAlign: 'left', align: 'left',
            hideSortIcons: true, minWidth: 130, flex: 0.9,
            renderCell: ({ row }) => (
                <Box>
                    <Box sx={{ fontSize: '12px', color: nabd[row.awb_number] ? 'error.dark' : 'text.secondary', fontWeight: nabd[row.awb_number] ? 600 : 400 }}>{row.edd ? parseDateAndTime(row.edd) : '—'}</Box>
                    {nabd[row.awb_number] && <LateTag breachType={nabd[row.awb_number].breachType} lateDays={nabd[row.awb_number].lateDays} />}
                </Box>
            ),
        },
        {
            field: 'invoice',
            headerName: 'Invoice', headerAlign: 'right', align: 'right',
            hideSortIcons: true, minWidth: 110, flex: 0.8,
            renderCell: ({ row }) => (
                <Box sx={{ fontSize: '13px', fontWeight: 700, color: 'text.primary', letterSpacing: '-0.01em' }}>
                    {row.invoice_value ? formatCurrency(row.invoice_value) : '—'}
                </Box>
            ),
        },
        {
            field: 'pod',
            headerName: 'POD', headerAlign: 'center', align: 'center',
            hideSortIcons: true, width: 80,
            renderCell: ({ row }) => {
                if (!row?.pods) return <Box sx={{ fontSize: '12px', color: 'text.disabled' }}>—</Box>;
                return (
                    <Box component="button" onClick={() => handlePodOpen(row.pods)}
                        sx={{ display: 'inline-flex', alignItems: 'center', px: '8px', py: '3px', borderRadius: '4px', fontSize: '11px', fontWeight: 600, cursor: 'pointer', bgcolor: 'transparent', color: '#2563eb', border: '1px solid #bfdbfe', transition: 'all 0.15s', '&:hover': { bgcolor: '#eff6ff', borderColor: '#93c5fd' } }}>
                        View
                    </Box>
                );
            },
        },
        {
            field: 'payment_mode',
            headerName: 'Payment', headerAlign: 'left', align: 'left',
            hideSortIcons: true, width: 100,
            renderCell: ({ row }) => <PaymentBadge mode={row?.payment_mode} />,
        },
        {
            field: 'action',
            headerName: 'Actions', headerAlign: 'center', align: 'center',
            hideSortIcons: true, width: 120,
            renderCell: ({ row }) => {
                const menuActions = [
                    { key: 'details', label: 'View details', icon: <VisibilityIcon fontSize="small" />, href: `/order-detail/${row.awb_number}` },
                    { key: 'resync', label: 'Resync status', icon: <SyncIcon fontSize="small" />, onClick: () => handleSync(row.awb_number), dividerBefore: true },
                    { key: 'recalc', label: 'Recalculate order value', icon: <FunctionsIcon fontSize="small" />, onClick: () => handleRecal(row.id) },
                    ...(row.orderStatus !== 'DELIVERED' ? [{ key: 'edd', label: 'Update EDD', icon: <ScheduleIcon fontSize="small" />, onClick: () => handleOpen(row) }] : []),
                    ...(row?.appointmentDeliveryData ? [{ key: 'appt', label: 'View appointment details', icon: <AssignmentIcon fontSize="small" />, onClick: () => { setEddRowData(row); setEddDataOpen(true); }, dividerBefore: true }] : []),
                    ...(row?.additionalDocuments ? [{ key: 'docs', label: 'View additional documents', icon: <DescriptionIcon fontSize="small" />, onClick: () => { setDocsViewRow(row); setDocsViewOpen(true); } }] : []),
                    ...(nonAbdOnly && nabd[row.awb_number] ? (() => {
                        const b = nabd[row.awb_number];
                        const open = () => setNabdCaseId(b.id);
                        if (b.breachType === 'D') return b.locked
                            ? [{ key: 'nabdView', label: 'View record and journey', icon: <TimelineIcon fontSize="small" />, onClick: open, dividerBefore: true },
                               { key: 'nabdReopen', label: 'Reopen record, senior only', icon: <LockOpenIcon fontSize="small" />, onClick: open }]
                            : [{ key: 'nabdView', label: 'View journey and attribution', icon: <TimelineIcon fontSize="small" />, onClick: open, dividerBefore: true },
                               { key: 'nabdClose', label: 'Close and attribute', icon: <FactCheckIcon fontSize="small" />, onClick: open }];
                        return [{ key: 'nabdView', label: 'View journey and attribution', icon: <TimelineIcon fontSize="small" />, onClick: open, dividerBefore: true },
                                { key: 'nabdAttr', label: b.owner === 'CLIENT' ? 'KAM reply' : b.owner ? 'Update attribution' : 'Attribute this delay', icon: <WarningAmberIcon fontSize="small" />, onClick: open }];
                    })() : []),
                    ...(row.orderStatus === 'DELIVERED' && !row.pods ? [{ key: 'pod', label: 'Refetch POD', icon: <DocumentScanner fontSize="small" />, onClick: () => handleFetchPOD(row.awb_number) }] : []),
                ];
                return (
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                        <OrderRowActions actions={menuActions} />
                        {!row.terminalStatus && (
                            <>
                                <Tooltip title={row.appointdeliveryRequired ? (row.appointmentDelivery ? 'Reschedule Appointment' : 'Choose Appointment Date') : (row.additionalDocuments ? 'Edit Additional Documents' : 'Add Additional Documents')}>
                                    <IconButton onClick={() => handleDelivery(row)} color="warning" size="small"
                                        sx={{ bgcolor: '#fff4e5', borderRadius: '6px', padding: '4px', '&:hover': { bgcolor: '#ed6c02', color: '#fff' }, '& svg': { fontSize: '16px !important' } }}>
                                        {row.appointdeliveryRequired ? <CalendarMonthIcon fontSize="small" /> : <UploadFileIcon fontSize="small" />}
                                    </IconButton>
                                </Tooltip>
                                <Tooltip title={`Convert to ${row.appointdeliveryRequired ? 'Non-ABD' : 'ABD'} Shipment`}>
                                    <Switch checked={row.appointdeliveryRequired} disabled={isAbdLoading} color="primary" size="small" onChange={() => handleAppointmentDeliveryFunc(row)} />
                                </Tooltip>
                            </>
                        )}
                    </Box>
                );
            },
        },
    ];


    // Switch-related functions
    const handleAppointmentDeliveryAgree = async () => {
        setIsAbdLoading(true);
        try {
            const response = await postGeneric(
                `${apiConstants.TOGGLE_APPOINTMENT_DELIVERY}?awbNumber=${abdData.awb_number}&statusCode=${!abdData.appointdeliveryRequired}&merchantOid=${abdData.merchantDetail?.key}`
            );
            enqueueSnackbar(
                response?.data?.message || "Appointment Delivery Updated Successfully",
                { variant: 'success' }
            );
            handleCloseAppointmentDelivery();
            refetch();
        } catch (error) {
            console.error('Appointment delivery update failed:', error);
            enqueueSnackbar(
                error?.response?.data?.message || "Failed to update appointment delivery",
                { variant: 'error' }
            );
        } finally {
            setIsAbdLoading(false);
        }
    };

    const handleCloseAppointmentDelivery = () => {
        setOpenAppointmentDelivery(false);
        setABDData(null);
        setIsAbdLoading(false);
    };

    const handleAppointmentDeliveryFunc = (rowData) => {
        setABDData(rowData);
        setOpenAppointmentDelivery(true);
    };

    const handleSelectionChange = (newSelectionModel) => {
        const currentRows = data?.data || [];
        const rowsById = {};
        currentRows.forEach((r) => { rowsById[r.id] = r; });

        setSelectedShipmentsMap((prev) => {
            const next = {};
            newSelectionModel.forEach((id) => {
                if (prev[id]) {
                    next[id] = prev[id];
                } else if (rowsById[id]) {
                    const row = rowsById[id];
                    next[id] = {
                        awbNumber: row.awb_number,
                        merchantOid: row?.merchantDetail?.key,
                    };
                }
            });
            return next;
        });
        setRowSelectionModel(newSelectionModel);
    };

    const openBulkConfirm = (statusCode) => {
        setBulkStatusCode(statusCode);
        setBulkConfirmOpen(true);
    };

    const handleCloseBulkConfirm = () => {
        if (isBulkAbdLoading) return;
        setBulkConfirmOpen(false);
    };

    const clearBulkSelection = () => {
        setRowSelectionModel([]);
        setSelectedShipmentsMap({});
    };

    const handleBulkAbdAgree = async () => {
        const items = Object.values(selectedShipmentsMap)
            .filter((it) => it.awbNumber && it.merchantOid)
            .map((it) => ({ awbNumber: it.awbNumber, merchantOid: it.merchantOid }));

        if (items.length === 0) {
            enqueueSnackbar('No valid shipments selected', { variant: 'warning' });
            return;
        }

        setIsBulkAbdLoading(true);
        try {
            const response = await postGeneric(
                apiConstants.BULK_TOGGLE_APPOINTMENT_DELIVERY,
                { statusCode: bulkStatusCode, items }
            );

            const responseObj = response?.data?.responseObj;
            const results = responseObj?.results || [];
            const total = responseObj?.total ?? items.length;
            const successCount = responseObj?.successCount ?? results.filter(r => r.status === 'SUCCESS').length;
            const failedCount = responseObj?.failedCount ?? results.filter(r => r.status === 'FAILED').length;

            setBulkResults({ total, successCount, failedCount, results, statusCode: bulkStatusCode });
            setBulkConfirmOpen(false);
            setBulkResultsOpen(true);

            if (successCount > 0 && failedCount === 0) {
                enqueueSnackbar(
                    `${bulkStatusCode ? 'Enabled' : 'Disabled'} ABD for ${successCount} shipment(s)`,
                    { variant: 'success' }
                );
            } else if (successCount > 0 && failedCount > 0) {
                enqueueSnackbar(
                    `${successCount} of ${total} updated, ${failedCount} failed`,
                    { variant: 'warning' }
                );
            } else if (successCount === 0 && failedCount > 0) {
                enqueueSnackbar(
                    `All ${failedCount} shipment(s) failed to update`,
                    { variant: 'error' }
                );
            } else {
                enqueueSnackbar(
                    response?.data?.message || 'Bulk update completed',
                    { variant: 'info' }
                );
            }
        } catch (error) {
            console.error('Bulk appointment delivery update failed:', error);
            enqueueSnackbar(
                error?.response?.data?.message || 'Failed to update appointment delivery',
                { variant: 'error' }
            );
        } finally {
            setIsBulkAbdLoading(false);
        }
    };

    const handleCloseBulkResults = () => {
        setBulkResultsOpen(false);
        setBulkResults(null);
        clearBulkSelection();
        refetch();
    };

    const friendlyResultMessage = (rawMessage, statusCode) => {
        if (!rawMessage) return '-';
        const normalized = String(rawMessage).trim().toLowerCase();
        if (normalized === 'no same status change is allowed') {
            return statusCode ? 'Already ABD-enabled' : 'Already Non-ABD';
        }
        return rawMessage;
    };


    // One call: forward, plus RTO when the order has gone RTO. The row refreshes when done.
    const handleRecal = (id) => {
        setIsCalculating(true);
        recalculatePricing({
            orderId: id
        })
            .then(() => {
                enqueueSnackbar("Order value recalculated", { variant: 'success' });
                setReload((r) => r + 1);
            })
            .catch((err) => enqueueSnackbar(err.message, { variant: err.variant || 'error' }))
            .finally(() => setIsCalculating(false));
    }


    const handleDelivery = (val) => {
        if (val?.appointdeliveryRequired) {
            setAppDetails(val);
            setDelConfirm(true);
        } else {
            setDocsRowData(val);
            setDocsModalOpen(true);
        }
    };

    const handlePodOpen = (row) => {
        setPods(true)
        setId(row)

    }
    const onSubmit = async (data) => {
        let pincodes
        if (nonAbdOnly && (data.state || data.city)) {
            try {
                pincodes = await fetchPincodes({ state: data.state || '', city: data.city || '' }, true).unwrap()
            } catch (e) {
                enqueueSnackbar(e?.data?.message || e?.message || 'Could not load the pincodes for this state / city', { variant: 'error' })
                return
            }
            if (!pincodes.length) enqueueSnackbar('No pincodes in the pincode master for this state / city.', { variant: 'info' })
        }
        setPage(0)
        setFiltersChange(filterChange + 1)
        setFilters(pincodes ? { ...data, pincodes } : data);
    }

    const handleOpen = (row) => {
        setAwb(row);
        setOpen(true)
    }
    const handleClose = () => {
        setOpen(false)
    }

    return (
        <>
            <PageTitle>{nonAbdOnly ? 'Non-ABD Shipments' : 'All B2B Shipments'}</PageTitle>
            {nonAbdOnly && <CaseDrawer open={!!nabdCaseId} caseId={nabdCaseId} onClose={() => setNabdCaseId(null)} />}
            {showAwbTabs && (
                <Box sx={{ mb: 1 }}>
                    <Tabs value={awbTab} onChange={handleAwbTabChange}
                        sx={{ borderBottom: '1px solid #e5e7eb', '& .MuiTab-root': { textTransform: 'none', fontWeight: 600, minWidth: 140 } }}>
                        <Tab value={AWB_TAB.GENERATED} label='AWB Generated' />
                        <Tab value={AWB_TAB.PENDING}
                            label={`AWB Not Generated${pendingCount != null ? ` · ${pendingCount}${pendingCount >= PENDING_AWB_LIMIT ? '+' : ''}` : ''}`} />
                    </Tabs>
                    <Typography sx={{ fontSize: '12px', color: '#888', mt: 1 }}>
                        {awbTab === AWB_TAB.PENDING
                            ? `Orders created in the last ${NON_ABD_DEFAULT_WINDOW_DAYS} days with no AWB registered yet.`
                            : `Shipments with AWB registered in the last ${NON_ABD_DEFAULT_WINDOW_DAYS} days.`}
                        {' '}Pick a date range or search an AWB to look further back.
                    </Typography>
                </Box>
            )}
            <MUIModal open={open} handleClose={handleClose} children={<Eddupdate awb={awb} setOpen={setOpen} setReload={setReload} setFilters={setFilters}
                setFiltersChange={setFiltersChange} filterChange={filterChange} />}
                title={`Please provide detail for updating the EDD of Awb Number ${awb?.awb_number}`} />
            <MUIModal
                open={delConfirm}
                handleClose={() => setDelConfirm(false)}
                maxWidth="lg"
                title={
                    <Typography variant="subtitle1" sx={{ mt: 1, display: 'flex', alignItems: 'center' }}>
                        Schedule Delivery Appointment - AWB{' : '}
                        <Typography component="span" color="error" fontWeight="bold">
                            {appDetails?.awb_number}
                        </Typography>
                        <CopyIcon text={appDetails?.awb_number} />
                    </Typography>
                }
                hideClose={true}
            >
                <AppointmentDelivery
                    rowData={appDetails}
                    setDelConfirm={setDelConfirm}
                    setReload={setReload}
                />
            </MUIModal>
            <MUIModal open={pods} handleClose={() => setPods(false)} children={<Pods id={id} />} title={"PODs Link"} maxWidth="md" />
            <Dialog
                open={eddDataOpen}
                onClose={() => { setEddDataOpen(false); setEddRowData(null); }}
                maxWidth="sm"
                fullWidth
            >
                <DialogTitle sx={{ pb: 1.5, borderBottom: '1px solid', borderColor: 'divider' }}>
                    <Typography variant="h6" fontWeight={700}>Appointment Delivery Details</Typography>
                    <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5, display: 'flex', alignItems: 'center' }}>
                        AWB: <strong>{eddRowData?.awb_number}</strong>
                        <CopyIcon text={eddRowData?.awb_number} />
                    </Typography>
                </DialogTitle>
                <DialogContent sx={{ pt: 2 }}>
                    {eddRowData?.appointmentDeliveryData && (() => {
                        const d = eddRowData.appointmentDeliveryData;
                        const fetchDoc = async (docType) => {
                            try {
                                const res = await getGeneric(apiConstants.APPOINTMENT_DELIVERY_DOC_URL, { awbNumber: eddRowData.awb_number, docType });
                                const url = res?.data?.responseObj?.url || res?.data?.url;
                                if (url) window.open(url, '_blank');
                                else enqueueSnackbar("Document URL missing", { variant: "warning" });
                            } catch (err) {
                                enqueueSnackbar(err?.response?.data?.message || "Failed to fetch document", { variant: "error" });
                            }
                        };
                        const fetchDocById = async (docId) => {
                            try {
                                const res = await getGeneric(apiConstants.APPOINTMENT_DELIVERY_DOC_URL, { awbNumber: eddRowData.awb_number, docId });
                                const url = res?.data?.responseObj?.url || res?.data?.url;
                                if (url) window.open(url, '_blank');
                                else enqueueSnackbar("Document URL missing", { variant: "warning" });
                            } catch (err) {
                                enqueueSnackbar(err?.response?.data?.message || "Failed to fetch document", { variant: "error" });
                            }
                        };
                        const docs = [
                            { label: "Invoice", key: d.appointment_del_invoice_s3_key, docType: "INVOICE" },
                            { label: "E-Way Bill", key: d.appointment_del_eway_bill_s3_key, docType: "EWAY_BILL" },
                            { label: "PO Copy", key: d.appointment_del_po_copy_s3_key, docType: "PO_COPY" },
                        ].filter(doc => doc.key);
                        return (
                            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2.5 }}>
                                {/* Appointment Window */}
                                <Box>
                                    <Typography variant="caption" fontWeight={700} color="primary" sx={{ textTransform: 'uppercase', letterSpacing: 0.8 }}>
                                        Appointment Window
                                    </Typography>
                                    <Divider sx={{ mt: 0.5, mb: 1.5 }} />
                                    <Grid container spacing={2}>
                                        <Grid item xs={6}>
                                            <Typography variant="caption" color="text.secondary">Start</Typography>
                                            <Typography variant="body2" fontWeight={500}>{parseDateAndTime(d.appointment_del_start) || '—'}</Typography>
                                        </Grid>
                                        <Grid item xs={6}>
                                            <Typography variant="caption" color="text.secondary">End</Typography>
                                            <Typography variant="body2" fontWeight={500}>{parseDateAndTime(d.appointment_del_end) || '—'}</Typography>
                                        </Grid>
                                    </Grid>
                                </Box>
                                {/* PO Details */}
                                <Box>
                                    <Typography variant="caption" fontWeight={700} color="primary" sx={{ textTransform: 'uppercase', letterSpacing: 0.8 }}>
                                        PO Details
                                    </Typography>
                                    <Divider sx={{ mt: 0.5, mb: 1.5 }} />
                                    <Grid container spacing={2}>
                                        <Grid item xs={6}>
                                            <Typography variant="caption" color="text.secondary">PO Number</Typography>
                                            <Typography variant="body2" fontWeight={500}>{d.appointment_del_po || '—'}</Typography>
                                        </Grid>
                                        <Grid item xs={6}>
                                            <Typography variant="caption" color="text.secondary">PO Expiry</Typography>
                                            <Typography variant="body2" fontWeight={500}>{d.appointment_del_po_expiry || '—'}</Typography>
                                        </Grid>
                                        {d.appointment_del_remarks && (
                                            <Grid item xs={12}>
                                                <Typography variant="caption" color="text.secondary">Remarks</Typography>
                                                <Typography variant="body2" fontWeight={500}>{d.appointment_del_remarks}</Typography>
                                            </Grid>
                                        )}
                                    </Grid>
                                </Box>
                                {/* Alternate Contacts */}
                                {(d.appointment_del_alt_contact_1 || d.appointment_del_alt_contact_2) && (
                                    <Box>
                                        <Typography variant="caption" fontWeight={700} color="primary" sx={{ textTransform: 'uppercase', letterSpacing: 0.8 }}>
                                            Alternate Contacts
                                        </Typography>
                                        <Divider sx={{ mt: 0.5, mb: 1.5 }} />
                                        <Grid container spacing={2}>
                                            {d.appointment_del_alt_contact_1 && (
                                                <Grid item xs={6}>
                                                    <Typography variant="caption" color="text.secondary">Contact 1</Typography>
                                                    <Typography variant="body2" fontWeight={500}>{d.appointment_del_alt_contact_1}</Typography>
                                                </Grid>
                                            )}
                                            {d.appointment_del_alt_contact_2 && (
                                                <Grid item xs={6}>
                                                    <Typography variant="caption" color="text.secondary">Contact 2</Typography>
                                                    <Typography variant="body2" fontWeight={500}>{d.appointment_del_alt_contact_2}</Typography>
                                                </Grid>
                                            )}
                                        </Grid>
                                    </Box>
                                )}
                                {/* Documents */}
                                {docs.length > 0 && (
                                    <Box>
                                        <Typography variant="caption" fontWeight={700} color="primary" sx={{ textTransform: 'uppercase', letterSpacing: 0.8 }}>
                                            Documents
                                        </Typography>
                                        <Divider sx={{ mt: 0.5, mb: 1.5 }} />
                                        <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap' }}>
                                            {docs.map(({ label, docType }) => (
                                                <Button key={docType} size="small" variant="contained" startIcon={<DocumentScanner />} onClick={() => fetchDoc(docType)}>
                                                    {label}
                                                </Button>
                                            ))}
                                        </Box>
                                    </Box>
                                )}
                                {Array.isArray(d.appointment_del_extra_docs) && d.appointment_del_extra_docs.length > 0 && (
                                    <Box>
                                        <Typography variant="caption" fontWeight={700} color="primary" sx={{ textTransform: 'uppercase', letterSpacing: 0.8 }}>
                                            Additional Documents
                                        </Typography>
                                        <Divider sx={{ mt: 0.5, mb: 1.5 }} />
                                        <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap' }}>
                                            {d.appointment_del_extra_docs.map((xd) => (
                                                <Button key={xd.docId} size="small" variant="outlined" startIcon={<DocumentScanner />} onClick={() => fetchDocById(xd.docId)}>
                                                    {xd.docLabel || categoryLabel(xd.docType)}
                                                </Button>
                                            ))}
                                        </Box>
                                    </Box>
                                )}
                                {/* Footer */}
                                <Typography variant="caption" color="text.secondary">
                                    Last modified by <strong>{d.modifiedByUser}</strong> on {parseDateAndTime(d.lastModifiedDate)}
                                </Typography>
                            </Box>
                        );
                    })()}
                </DialogContent>
                <DialogActions sx={{ px: 3, pb: 2 }}>
                    <Button onClick={() => { setEddDataOpen(false); setEddRowData(null); }} variant="outlined">Close</Button>
                </DialogActions>
            </Dialog>
            <MUIModal
                open={docsModalOpen}
                handleClose={() => { setDocsModalOpen(false); setDocsRowData(null); }}
                maxWidth="lg"
                title={
                    <Typography variant="subtitle1" sx={{ mt: 1, display: 'flex', alignItems: 'center' }}>
                        Additional Documents - AWB{' : '}
                        <Typography component="span" color="error" fontWeight="bold">
                            {docsRowData?.awb_number}
                        </Typography>
                        <CopyIcon text={docsRowData?.awb_number} />
                    </Typography>
                }
                hideClose={true}
            >
                <AddAdditionalDocuments
                    rowData={docsRowData}
                    setOpen={setDocsModalOpen}
                    setReload={setReload}
                />
            </MUIModal>
            <MUIModal
                open={apptDocsOpen}
                handleClose={() => { setApptDocsOpen(false); setApptDocsRow(null); }}
                maxWidth="md"
                title={
                    <Typography variant="subtitle1" sx={{ mt: 1, display: 'flex', alignItems: 'center' }}>
                        Add Documents - AWB{' : '}
                        <Typography component="span" color="error" fontWeight="bold">
                            {apptDocsRow?.awb_number}
                        </Typography>
                        <CopyIcon text={apptDocsRow?.awb_number} />
                    </Typography>
                }
                hideClose={true}
            >
                <DocumentsModal
                    rowData={apptDocsRow}
                    setOpen={setApptDocsOpen}
                    setReload={setReload}
                />
            </MUIModal>
            <Dialog
                open={docsViewOpen}
                onClose={() => { setDocsViewOpen(false); setDocsViewRow(null); }}
                maxWidth="sm"
                fullWidth
            >
                <DialogTitle sx={{ pb: 1.5, borderBottom: '1px solid', borderColor: 'divider' }}>
                    <Typography variant="h6" fontWeight={700}>Additional Documents</Typography>
                    <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5, display: 'flex', alignItems: 'center' }}>
                        AWB: <strong>{docsViewRow?.awb_number}</strong>
                        <CopyIcon text={docsViewRow?.awb_number} />
                    </Typography>
                </DialogTitle>
                <DialogContent sx={{ pt: 2 }}>
                    {docsViewRow?.additionalDocuments && (() => {
                        const d = docsViewRow.additionalDocuments;
                        const fetchDoc = async (docType) => {
                            try {
                                const res = await getGeneric(apiConstants.ADDITIONAL_DOCUMENTS_DOC_URL, { awbNumber: docsViewRow.awb_number, docType });
                                const url = res?.data?.responseObj?.url || res?.data?.url;
                                if (url) window.open(url, '_blank');
                                else enqueueSnackbar("Document URL missing", { variant: "warning" });
                            } catch (err) {
                                enqueueSnackbar(err?.response?.data?.message || "Failed to fetch document", { variant: "error" });
                            }
                        };
                        const fetchDocById = async (docId) => {
                            try {
                                const res = await getGeneric(apiConstants.ADDITIONAL_DOCUMENTS_DOC_URL, { awbNumber: docsViewRow.awb_number, docId });
                                const url = res?.data?.responseObj?.url || res?.data?.url;
                                if (url) window.open(url, '_blank');
                                else enqueueSnackbar("Document URL missing", { variant: "warning" });
                            } catch (err) {
                                enqueueSnackbar(err?.response?.data?.message || "Failed to fetch document", { variant: "error" });
                            }
                        };
                        const docs = [
                            { label: "Invoice", key: d.invoiceS3Key, docType: "INVOICE" },
                            { label: "E-Way Bill", key: d.ewayBillS3Key, docType: "EWAY_BILL" },
                            { label: "PO Copy", key: d.poCopyS3Key, docType: "PO_COPY" },
                        ].filter(doc => doc.key);
                        return (
                            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2.5 }}>
                                <Box>
                                    <Typography variant="caption" fontWeight={700} color="primary" sx={{ textTransform: 'uppercase', letterSpacing: 0.8 }}>
                                        PO Details
                                    </Typography>
                                    <Divider sx={{ mt: 0.5, mb: 1.5 }} />
                                    <Grid container spacing={2}>
                                        <Grid item xs={6}>
                                            <Typography variant="caption" color="text.secondary">PO Number</Typography>
                                            <Typography variant="body2" fontWeight={500}>{d.poNumber || '—'}</Typography>
                                        </Grid>
                                        <Grid item xs={6}>
                                            <Typography variant="caption" color="text.secondary">PO Expiry</Typography>
                                            <Typography variant="body2" fontWeight={500}>{d.poExpiry || '—'}</Typography>
                                        </Grid>
                                    </Grid>
                                </Box>
                                {(d.altContact1 || d.altContact2) && (
                                    <Box>
                                        <Typography variant="caption" fontWeight={700} color="primary" sx={{ textTransform: 'uppercase', letterSpacing: 0.8 }}>
                                            Alternate Contacts
                                        </Typography>
                                        <Divider sx={{ mt: 0.5, mb: 1.5 }} />
                                        <Grid container spacing={2}>
                                            {d.altContact1 && (
                                                <Grid item xs={6}>
                                                    <Typography variant="caption" color="text.secondary">Contact 1</Typography>
                                                    <Typography variant="body2" fontWeight={500}>{d.altContact1}</Typography>
                                                </Grid>
                                            )}
                                            {d.altContact2 && (
                                                <Grid item xs={6}>
                                                    <Typography variant="caption" color="text.secondary">Contact 2</Typography>
                                                    <Typography variant="body2" fontWeight={500}>{d.altContact2}</Typography>
                                                </Grid>
                                            )}
                                        </Grid>
                                    </Box>
                                )}
                                {docs.length > 0 && (
                                    <Box>
                                        <Typography variant="caption" fontWeight={700} color="primary" sx={{ textTransform: 'uppercase', letterSpacing: 0.8 }}>
                                            Documents
                                        </Typography>
                                        <Divider sx={{ mt: 0.5, mb: 1.5 }} />
                                        <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap' }}>
                                            {docs.map(({ label, docType }) => (
                                                <Button key={docType} size="small" variant="contained" startIcon={<DocumentScanner />} onClick={() => fetchDoc(docType)}>
                                                    {label}
                                                </Button>
                                            ))}
                                        </Box>
                                    </Box>
                                )}
                                {Array.isArray(d.extraDocs) && d.extraDocs.length > 0 && (
                                    <Box>
                                        <Typography variant="caption" fontWeight={700} color="primary" sx={{ textTransform: 'uppercase', letterSpacing: 0.8 }}>
                                            Additional Documents
                                        </Typography>
                                        <Divider sx={{ mt: 0.5, mb: 1.5 }} />
                                        <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap' }}>
                                            {d.extraDocs.map((xd) => (
                                                <Button key={xd.docId} size="small" variant="outlined" startIcon={<DocumentScanner />} onClick={() => fetchDocById(xd.docId)}>
                                                    {xd.docLabel || categoryLabel(xd.docType)}
                                                </Button>
                                            ))}
                                        </Box>
                                    </Box>
                                )}
                                {(d.modifiedByUser || d.lastModifiedDate) && (
                                    <Typography variant="caption" color="text.secondary">
                                        Last modified
                                        {d.modifiedByUser ? <> by <strong>{d.modifiedByUser}</strong></> : ''}
                                        {d.lastModifiedDate ? ` on ${parseDateAndTime(d.lastModifiedDate)}` : ''}
                                    </Typography>
                                )}
                            </Box>
                        );
                    })()}
                </DialogContent>
                <DialogActions sx={{ px: 3, pb: 2 }}>
                    <Button onClick={() => { setDocsViewOpen(false); setDocsViewRow(null); }} variant="outlined">Close</Button>
                </DialogActions>
            </Dialog>
            <Dialog
                open={openAppointmentDelivery}
                onClose={handleCloseAppointmentDelivery}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                maxWidth="sm"
                fullWidth
            >
                <DialogTitle id="alert-dialog-title" sx={{ pb: 1 }}>
                    <Typography variant="h6" component="div">
                        Confirm ABD-Non-ABD Conversion
                    </Typography>
                    {abdData && (
                        <Typography variant="body2" color="text.secondary" sx={{ mt: 1, display: 'flex', alignItems: 'center' }}>
                            AWB: <strong>{abdData.awb_number}</strong>
                            <CopyIcon text={abdData.awb_number} />
                        </Typography>
                    )}
                </DialogTitle>

                <DialogContent sx={{ pb: 2 }}>
                    <DialogContentText id="alert-dialog-description">
                        <Typography variant="body1" sx={{ mb: 1 }}>
                            This shipment is being converted to{" "}
                            <strong>
                                {!abdData?.appointdeliveryRequired
                                    ? "Appointment-Based Delivery (ABD)"
                                    : "Non-Appointment-Based Delivery (Non-ABD)"}
                            </strong>
                        </Typography>

                        {!abdData?.appointdeliveryRequired && (
                            <Typography variant="body2" sx={{ mb: 1 }}>
                                Please ensure that the Appointment Date is set using the yellow calendar icon (📅).
                            </Typography>
                        )}

                        {!abdData?.appointdeliveryRequired && (
                            <Typography variant="body2" sx={{ mb: 2 }}>
                                TAT will now be calculated based on the Appointment Date.
                            </Typography>
                        )}

                        <Typography variant="body1" fontWeight="medium">
                            Do you wish to proceed?
                        </Typography>
                    </DialogContentText>
                </DialogContent>
                <DialogActions sx={{ px: 3, pb: 2 }}>
                    <Button
                        onClick={handleCloseAppointmentDelivery}
                        color="error"
                        variant="outlined"
                        disabled={isAbdLoading}
                    >
                        Cancel
                    </Button>
                    <LoadingButton
                        onClick={handleAppointmentDeliveryAgree}
                        color="primary"
                        variant="contained"
                        loading={isAbdLoading}
                    >
                        Confirm
                    </LoadingButton>
                </DialogActions>
            </Dialog>
            <Dialog
                open={bulkConfirmOpen}
                onClose={handleCloseBulkConfirm}
                aria-labelledby="bulk-abd-dialog-title"
                aria-describedby="bulk-abd-dialog-description"
                maxWidth="sm"
                fullWidth
            >
                <DialogTitle id="bulk-abd-dialog-title" sx={{ pb: 1 }}>
                    <Typography variant="h6" component="div">
                        {bulkStatusCode ? 'Enable' : 'Disable'} ABD for Multiple Shipments
                    </Typography>
                </DialogTitle>
                <DialogContent sx={{ pb: 2 }}>
                    <DialogContentText id="bulk-abd-dialog-description">
                        <Typography variant="body1" sx={{ mb: 1 }}>
                            You are changing status of{' '}
                            <strong>{Object.keys(selectedShipmentsMap).length}</strong> shipment(s) to{' '}
                            <strong>
                                {bulkStatusCode
                                    ? 'Appointment-Based Delivery (ABD)'
                                    : 'Non-Appointment-Based Delivery (Non-ABD)'}
                            </strong>.
                        </Typography>
                        {bulkStatusCode && (
                            <Typography variant="body2" sx={{ mb: 1 }}>
                                Appointment date/time slot can still be entered manually afterward using the calendar icon.
                            </Typography>
                        )}
                        <Typography variant="body1" fontWeight="medium" sx={{ mt: 1 }}>
                            Please confirm to proceed, or decline to cancel.
                        </Typography>
                    </DialogContentText>
                </DialogContent>
                <DialogActions sx={{ px: 3, pb: 2 }}>
                    <Button
                        onClick={handleCloseBulkConfirm}
                        color="error"
                        variant="outlined"
                        disabled={isBulkAbdLoading}
                    >
                        Decline
                    </Button>
                    <LoadingButton
                        onClick={handleBulkAbdAgree}
                        color="primary"
                        variant="contained"
                        loading={isBulkAbdLoading}
                    >
                        Confirm
                    </LoadingButton>
                </DialogActions>
            </Dialog>
            <Dialog
                open={bulkResultsOpen}
                onClose={handleCloseBulkResults}
                aria-labelledby="bulk-abd-results-title"
                maxWidth="md"
                fullWidth
            >
                <DialogTitle id="bulk-abd-results-title" sx={{ pb: 1 }}>
                    <Typography variant="h6" component="div">
                        Bulk {bulkResults?.statusCode ? 'Enable' : 'Disable'} ABD - Results
                    </Typography>
                </DialogTitle>
                <DialogContent sx={{ pb: 2 }}>
                    {bulkResults && (
                        <>
                            <Box sx={{ display: 'flex', gap: 1.5, flexWrap: 'wrap', mb: 2 }}>
                                <Chip
                                    label={`Total: ${bulkResults.total}`}
                                    variant="outlined"
                                    size="small"
                                />
                                <Chip
                                    label={`Success: ${bulkResults.successCount}`}
                                    color="success"
                                    variant={bulkResults.successCount > 0 ? 'filled' : 'outlined'}
                                    size="small"
                                />
                                <Chip
                                    label={`Failed: ${bulkResults.failedCount}`}
                                    color="error"
                                    variant={bulkResults.failedCount > 0 ? 'filled' : 'outlined'}
                                    size="small"
                                />
                            </Box>
                            <TableContainer component={Paper} variant="outlined" sx={{ maxHeight: 400 }}>
                                <Table size="small" stickyHeader>
                                    <TableHead>
                                        <TableRow>
                                            <TableCell sx={{ fontWeight: 700 }}>AWB Number</TableCell>
                                            <TableCell sx={{ fontWeight: 700 }}>Status</TableCell>
                                            <TableCell sx={{ fontWeight: 700 }}>Message</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {bulkResults.results.length === 0 && (
                                            <TableRow>
                                                <TableCell colSpan={3} align="center">
                                                    <Typography variant="body2" color="text.secondary">
                                                        No per-shipment details returned.
                                                    </Typography>
                                                </TableCell>
                                            </TableRow>
                                        )}
                                        {bulkResults.results.map((r, idx) => (
                                            <TableRow key={`${r.awbNumber}-${idx}`}>
                                                <TableCell>
                                                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                                        {r.awbNumber}
                                                        <CopyIcon text={r.awbNumber} />
                                                    </Box>
                                                </TableCell>
                                                <TableCell>
                                                    <Chip
                                                        label={r.status}
                                                        size="small"
                                                        color={r.status === 'SUCCESS' ? 'success' : 'error'}
                                                        variant="outlined"
                                                    />
                                                </TableCell>
                                                <TableCell>{friendlyResultMessage(r.message, bulkResults.statusCode)}</TableCell>
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </>
                    )}
                </DialogContent>
                <DialogActions sx={{ px: 3, pb: 2 }}>
                    <Button
                        onClick={handleCloseBulkResults}
                        color="primary"
                        variant="contained"
                    >
                        Close
                    </Button>
                </DialogActions>
            </Dialog>
            {(isFetching || isLoading || isCalculating) && <Loader />}

            {/* ── Filter bar ────────────────────────────────────────────── */}
            <Card sx={{ mb: 2, boxShadow: '0 1px 3px rgba(0,0,0,0.05)', borderRadius: '8px' }}>
                <CardContent sx={{ p: 2, '&:last-child': { pb: 2 } }}>
                    <FormProvider methods={methods} onSubmit={handleSubmit(onSubmit)}>
                        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1.5, alignItems: 'flex-end' }}>
                            <FilterField>
                                <FieldLabel>Merchant</FieldLabel>
                                <MerchantFilterCached fullWidth />
                            </FilterField>
                            <FilterField>
                                <FieldLabel>Courier</FieldLabel>
                                <CourierFilter filterList={"B2B"} />
                            </FilterField>
                            <FilterField>
                                <FieldLabel>Order Number</FieldLabel>
                                <RHFTextField name="reference" label="" placeholder="Order Number" fullWidth size="small" InputLabelProps={{ shrink: true }} />
                            </FilterField>
                            <FilterField>
                                <FieldLabel>AWB Number(s) — comma separated</FieldLabel>
                                <RHFTextField name="awb" label="" placeholder="AWB1, AWB2, AWB3" fullWidth size="small" InputLabelProps={{ shrink: true }} />
                            </FilterField>
                            {nonAbdOnly ? <>
                                <FilterField>
                                    <FieldLabel>State</FieldLabel>
                                    <GeoStateFilter />
                                </FilterField>
                                <FilterField>
                                    <FieldLabel>City</FieldLabel>
                                    <GeoCityFilter />
                                </FilterField>
                            </> : <>
                                <FilterField>
                                    <FieldLabel>City</FieldLabel>
                                    <RHFTextField name="city" label="" placeholder="City" fullWidth size="small" InputLabelProps={{ shrink: true }} disabled />
                                </FilterField>
                                <FilterField>
                                    <FieldLabel>State</FieldLabel>
                                    <RHFTextField name="state" label="" placeholder="State" fullWidth size="small" InputLabelProps={{ shrink: true }} disabled />
                                </FilterField>
                            </>}
                            <FilterDateField>
                                <FieldLabel>Created Date</FieldLabel>
                                <RHFDateRangePickerField name="created_date" label="" placeholder="Select date range" size="small" maxDate={new Date()} />
                            </FilterDateField>
                            <FilterField>
                                <FieldLabel>Order Status</FieldLabel>
                                <OrderStatusFilter />
                            </FilterField>
                            {!nonAbdOnly && <FilterField>
                                <FieldLabel>Delivery Type</FieldLabel>
                                <RHFSelectField name="appointdeliveryRequired" variant="outlined" width="100%" label="" placeholder="Select Delivery Type" size="small" displayEmpty
                                    options={[
                                        { label: "ABD", value: true },
                                        { label: "Non-ABD", value: false },
                                    ]}
                                />
                            </FilterField>}
                            <Box sx={{ display: 'flex', gap: 1, alignItems: 'center', flex: '0 0 auto' }}>
                                <Box component="button" type="submit"
                                    sx={{ fontSize: '12px', fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.5px', px: '20px', py: '8px', borderRadius: '6px', border: 'none', cursor: 'pointer', bgcolor: '#1565c0', color: '#fff', '&:hover': { bgcolor: '#0d47a1' } }}>
                                    Filter
                                </Box>
                                <Box component="button" type="button"
                                    onClick={() => { reset({ status: [], courier: '', merchant: '', reference: '', awb: '', city: '', state: '', fromDate: '', toDate: '', channel: '' }); setFilters([]); setPage(0); setFiltersChange(filterChange + 1); }}
                                    sx={{ fontSize: '12px', fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.5px', px: '20px', py: '8px', borderRadius: '6px', border: 'none', cursor: 'pointer', bgcolor: '#ef4444', color: '#fff', '&:hover': { bgcolor: '#dc2626' } }}>
                                    Reset
                                </Box>
                            </Box>
                        </Box>
                        <OrderStatusChips applied={filters.status} onApply={onSubmit} />
                    </FormProvider>
                </CardContent>
            </Card>

            {/* ── Selection toolbar ─────────────────────────────────────── */}
            {Object.keys(selectedShipmentsMap).length > 0 && (
                <Box sx={{ mb: 1.5, px: 2.5, py: 1.25, bgcolor: '#e3f2fd', borderRadius: '8px', border: '1px solid #bbdefb', display: 'flex', alignItems: 'center', gap: 2, flexWrap: 'wrap' }}>
                    <Typography sx={{ fontSize: '13px', fontWeight: 600, color: '#1565c0' }}>
                        {Object.keys(selectedShipmentsMap).length} shipment{Object.keys(selectedShipmentsMap).length !== 1 ? 's' : ''} selected
                    </Typography>
                    <Box sx={{ ml: 'auto', display: 'flex', gap: 1, flexWrap: 'wrap' }}>
                        <Button variant="contained" size="small" disableElevation onClick={() => openBulkConfirm(true)}
                            sx={{ fontSize: '12px', fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.4px', px: 2, bgcolor: '#1565c0', '&:hover': { bgcolor: '#0d47a1', boxShadow: 'none' } }}>
                            Enable ABD
                        </Button>
                        <Button variant="outlined" size="small" onClick={() => openBulkConfirm(false)}
                            sx={{ fontSize: '12px', fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.4px', px: 2, color: '#1565c0', borderColor: '#1565c0', '&:hover': { bgcolor: '#eff6ff' } }}>
                            Disable ABD
                        </Button>
                        <Button variant="text" size="small" color="error" onClick={clearBulkSelection}
                            sx={{ fontSize: '12px', fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.4px' }}>
                            Clear
                        </Button>
                    </Box>
                </Box>
            )}

            {/* ── Data table ────────────────────────────────────────────── */}
            <Box sx={{ bgcolor: '#fff', borderRadius: 2, boxShadow: '0 1px 3px rgba(0,0,0,0.05)' }}>
                <ProzoDataGrid
                    columns={columns}
                    autoHeight={true}
                    rows={(data?.data && data?.data.length > 0) ? data?.data : []}
                    sizePerPage={sizePerPage}
                    setSizePerPage={setSizePerPage}
                    setPage={setPage}
                    page={page}
                    pagination={true}
                    hideFooterPagination={false}
                    filterMode={"server"}
                    getRowHeight={() => 'auto'}
                    rowCount={knownRowCount}
                    getRowId={(row) => row.id}
                    checkboxSelection={true}
                    rowSelectionModel={rowSelectionModel}
                    setRowSelectionModel={handleSelectionChange}
                    keepNonExistentRowsSelected={true}
                    isRowSelectable={(params) => !params.row.terminalStatus}
                />
            </Box>
        </>
    );
};

export default B2BOrderSummary;